import React from "react";
import { useTheme } from "../theme/ThemeProvider";

/**
 * Theme-aware PBCoach.app logo. Swaps between logo-light.png (dark artwork
 * on light bg) and logo-dark.png (light artwork on dark bg) based on the
 * current global theme. Pass `variant="fixed-dark"` when you're on a
 * component that's always on a dark background (e.g. the Login/Landing
 * hero panels that don't recolour with the theme toggle).
 */
export default function Logo({ className = "h-9 w-auto", variant, testId = "logo" }) {
  const { theme } = useTheme();
  const useDarkArtwork =
    variant === "fixed-dark" ? true :
    variant === "fixed-light" ? false :
    theme !== "light";
  const src = useDarkArtwork ? "/logo-dark.png" : "/logo-light.png";
  return (
    <img
      src={src}
      alt="PBCoach.app"
      className={`${className} object-contain shrink-0`}
      data-testid={testId}
    />
  );
}
